import Input from "src/components/inputs/Input";
import SensitiveTextarea from "src/components/inputs/SensitiveTextarea";

interface OAuthWebexTabProps {
  adminLogin: boolean;
  onAdminLoginChange: (value: boolean) => void;
  dashboardLogin: boolean;
  onDashboardLoginChange: (value: boolean) => void;
  clientId: string;
  onClientIdChange: (value: string) => void;
  clientSecret: string;
  onClientSecretChange: (value: string) => void;
  scope: string;
  onScopeChange: (value: string) => void;
  disableInputs: boolean;
}

const OAuthWebexTab = ({
  adminLogin,
  onAdminLoginChange,
  dashboardLogin,
  onDashboardLoginChange,
  clientId,
  onClientIdChange,
  clientSecret,
  onClientSecretChange,
  scope,
  onScopeChange,
  disableInputs,
}: OAuthWebexTabProps) => (
  <>
    <h3 className="text-lg font-medium text-gray-900">Webex OAuth</h3>
    <div className="space-y-4">
      <label className="flex items-center gap-2">
        <input
          type="checkbox"
          checked={adminLogin}
          onChange={(e) => onAdminLoginChange(e.target.checked)}
          disabled={disableInputs}
          className="rounded border-gray-300"
        />
        <span className="text-sm font-medium text-gray-700">Admin Login</span>
      </label>
      <label className="flex items-center gap-2">
        <input
          type="checkbox"
          checked={dashboardLogin}
          onChange={(e) => onDashboardLoginChange(e.target.checked)}
          disabled={disableInputs}
          className="rounded border-gray-300"
        />
        <span className="text-sm font-medium text-gray-700">Dashboard Login</span>
      </label>
    </div>
    <Input
      type="text"
      label="Client ID"
      placeholder="Enter Webex Client ID"
      value={clientId}
      onChange={(e) => onClientIdChange(e.target.value)}
      required={false}
      disabled={disableInputs}
    />
    <SensitiveTextarea
      label="Client Secret"
      placeholder="Enter Webex Client Secret"
      value={clientSecret}
      onChange={onClientSecretChange}
      required={false}
      disabled={disableInputs}
    />
    <Input
      type="text"
      label="Scope"
      placeholder="Enter Scope"
      value={scope}
      onChange={(e) => onScopeChange(e.target.value)}
      required={false}
      disabled={disableInputs}
    />
  </>
);

export default OAuthWebexTab;
